<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
  <div id="delete-access-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-left">
            <div class="text-3xl mt-5">
              {{ $t('admin.accessDeleteConfirm') }}
            </div>
            <div class="text-gray-600 mt-2">{{ admin.name }} {{ admin.lastname }}</div>
            <div
              class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
              v-if="isAccessDeleting"
            >
              <LoadingIcon icon="three-dots" class="w-8 h-8" />
            </div>
          </div>
          <div class="flex mb-3">
            <div class="px-5 pb-8 text-center flex-1">
              <button
                type="button"
                data-dismiss="modal"
                @click="hideDeleteAccessModal()"
                v-if="!this.isAccessDeleting"
                class="btn btn-outline-secondary w-40 dark:border-dark-5 dark:text-gray-300 mr-1"
              >
                {{ $t('common.close') }}
              </button>
            </div>
            <div class="px-5 pb-8 text-center flex-1">
              <button
                type="button"
                class="btn btn-danger w-40"
                v-if="!this.isAccessDeleting"
                @click="modifyAccess(false)"
              >
                {{ $t('employee.deleteAccess') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('admin.accessModified') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('admin.accessNotModified') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import Toastify from 'toastify-js'
import langs from '@/locale.tabulator'
import adminApi from '@/services/admin-users/admin.api'

export default defineComponent({
  data() {
    return {
      tabulator: null,
      isAccessDeleting: false,
      admin: {
        uuid: null,
        name: null,
        lastname: null,
        active: null
      }
    }
  },
  methods: {
    showDetail(e, cell) {
      this.$router.push({
        name: 'side-menu-admins-detail',
        params: { uuid: cell.getData().uuid }
      })
    },
    showEdit(e, cell) {
      this.$router.push({
        name: 'side-menu-admins-edit',
        params: { uuid: cell.getData().uuid }
      })
    },
    showDeleteAccessModal() {
      cash('#delete-access-modal').modal('show')
    },
    hideDeleteAccessModal() {
      this.admin = {
        uuid: null,
        name: null,
        lastname: null,
        adminAccess: null
      }
      cash('#delete-access-modal').modal('hide')
    },
    modifyAccess(active) {
      this.isAccessDeleting = true
      adminApi.editAdminAccess(this.admin.uuid, { active: active }).then(
        (response) => {
          Toastify({
            node: cash('#success-notification-content').clone().removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.isAccessDeleting = false
          this.tabulator.setData()
          this.hideDeleteAccessModal()
        },
        (error) => {
          console.log(error)
          this.loading = false
          Toastify({
            node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.isAccessDeleting = false
        }
      )
    },
    toggleAccess(e, cell) {
      this.admin = cell.getData()
      if (cell.getData().active) {
        this.showDeleteAccessModal()
        return
      }
      this.modifyAccess(true)
    },
    detailFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-info detail-action">' +
        this.$t('common.detail') +
        '</button></div>'
      )
    },
    editFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('common.edit') +
        '</button></div>'
      )
    },
    adminAccessFormatter(cell) {
      if (cell.getData().active) {
        return (
          '<div class="flex lg:justify-center items-center"><button class="btn btn-dark detail-action">' +
          this.$t('employee.deleteAccess') +
          '</button></div>'
        )
      }
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-dark detail-action">' +
        this.$t('employee.createAccess') +
        '</button></div>'
      )
    }
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function (url, config, params) {
        console.log(url)
        console.log(params)
        console.log(config)
        return adminApi.getList(params.page, params.size)
      },
      ajaxResponse: function (url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.personName'),
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">
                ${cell.getData().name} ${cell.getData().lastname}
                </div>
              </div>`
          }
        },
        {
          title: 'Email',
          minWidth: 200,
          responsive: 0,
          field: 'email',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">
                ${cell.getData().email}
                </div>
              </div>`
          }
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionEdit',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionAccess',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.adminAccessFormatter,
          cellClick: this.toggleAccess
        }
      ]
    })
  }
})
</script>
